import { Component } from '@angular/core';
import { provideFlatpickrDefaults } from 'angularx-flatpickr';
import { getFlatpickrDefaults } from '../flatpickr-defaults';
import { FilterSelectComponent } from '../filter-select/filter-select.component';

export * from '../filter-select/filter-select.component';

@Component({
  selector: 'app-log-select',
  standalone: true,
  imports: [FilterSelectComponent],
  template: `
    <app-filter-select
      [header]="header"
      [reports]="reports"
      [consumer]="consumer"
      [showSites]="showSites"
      [SiteOnly]="SiteOnly"
      [showLocation]="showLocation"
      [MultiSites]="MultiSites"
      [AllSites]="AllSites"
      [AllSelection]="AllSelection"
      [FromToLocation]="FromToLocation"
      [ShowLocationDropdown]="ShowLocationDropdown"
      [SingleLocationDropdown]="SingleLocationDropdown"
      [Nolocation]="Nolocation"
      [locationId]="locationId"
      [showDaterange]="showDaterange"
      [showSingleDate]="showSingleDate"
      [Date_Flat]="Date_Flat"
      [Date_Time]="Date_Time"
      [DateTimerange]="DateTimerange"
      [Date_time]="Date_time"
      [Month_Year]="Month_Year"
      [Month_Range]="Month_Range"
      [timeDuration]="timeDuration"
      [selectedfiltersType]="selectedfiltersType"
      [showappliances]="showappliances"
      [showsubtype]="showsubtype"
      [showBillNo]="showBillNo"
      [Hours]="Hours"
      [search]="search"
      [dropdown]="dropdown"
      [dropdownOptions]="dropdownOptions"
      [placeholder]="placeholder"
      [InputField]="InputField"
      [InputFields]="InputFields"
      [filterConfig]="filterConfig"
      (filtersApplied)="filtersApplied.emit($event)"
      (showTable)="showTable.emit($event)"
      (consumerListing)="consumerListing.emit($event)">
    </app-filter-select>
  `,
  styles: [':host { display: block; }'],
  providers: [provideFlatpickrDefaults(getFlatpickrDefaults())],
})
export class LogSelectComponent extends FilterSelectComponent {}